import React, { Component } from 'react';
import { getContractingUnit, getProject } from '../../shared/util';
import UprinceNavigation from '../../shared/uprinceNavigation/cuProjectNavigation/component';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { v4 as uuidv4 } from 'uuid';
import WbsMainLayout from './wbsMainLayout';
import { FluentProvider } from '@fluentui/react-components';
import { uPrinceFluentLightTheme } from '../../../fluentTheme';

interface Props {
  currentUser: any;
}

interface State {
  isContractUnit: boolean;
  isProject: boolean;
}

export class WBS extends Component<Props, State> {
  render() {
    return <DndProvider key={uuidv4()} backend={HTML5Backend}>
      <UprinceNavigation
        currentUser={this.props.currentUser}
        selectedNavigationIndex={`/CU/${getContractingUnit()}/project/${getProject()}/wbs`}
      >
        <FluentProvider theme={uPrinceFluentLightTheme}>
          <WbsMainLayout />
        </FluentProvider>
      </UprinceNavigation>
    </DndProvider>;

  }
}

export default (WBS);
